module.exports = __webpack_public_path__ + "static/img/duoduoBg.e2e9b88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/duoduoBg.png
// module id = X3rB
// module chunks = 1